import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import {
  CREATE_DECORATIVE_ORDER,
  CREATE_RAW_ORDER,
  EDIT_RAW_ORDER,
  EDIT_DECORATIVE_ORDER,
  ORDER_ROUTE,
  CREATE_SERIES_PRODUCT_ORDER,
  EDIT_SERIES_PRODUCT_ORDER,
  RAW_APPROVAL_VIEW_ROUTE,
  DECORATIVE_APPROVAL_VIEW_ROUTE,
  SERIES_PRODUCT_APPROVAL_VIEW_ROUTE
} from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy imports
const Order = lazy(() => import("app/pages/Order"));
const EditRawOrderMain = lazy(() => import("app/pages/Order/RawOrder/Edit"));
const CreateRawOrderMain = lazy(() => import("app/pages/Order/RawOrder/Create"));
const CreateDecorativeOrder = lazy(() => import("app/pages/Order/DecorativeOrder/Create"));
const EditDecorativeOrder = lazy(() => import("app/pages/Order/DecorativeOrder/Edit"));
const CreateSeriesProductOrder = lazy(() => import("app/pages/Order/SeriesProductOrder/Create"));
const EditSeriesProductOrder = lazy(() => import("app/pages/Order/SeriesProductOrder/Edit"));
const RawApprovalView = lazy(() => import("app/pages/Order/RawApproval/ViewRawApproval"));
const DecorativeApprovalView = lazy(() => import("app/pages/Order/DecorativeApproval/ViewDecorativeApproval"));
const SeriesProductApprovalView = lazy(() => import("app/pages/Order/SeriesProductApprval/ViewSeriesProductApproval"));

export const orderModuleRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "order_permission", "view"],
      },
    ],
    routes: [
      {
        path: ORDER_ROUTE,
        element: LoadablePage(Order),
      },
      {
        path: CREATE_RAW_ORDER,
        element: LoadablePage(CreateRawOrderMain),
      },
      {
        path: EDIT_RAW_ORDER,
        element: LoadablePage(EditRawOrderMain),
      },
      {
        path: CREATE_DECORATIVE_ORDER,
        element: LoadablePage(CreateDecorativeOrder),
      },
      {
        path: EDIT_DECORATIVE_ORDER,
        element: LoadablePage(EditDecorativeOrder),
      },
      {
        path: CREATE_SERIES_PRODUCT_ORDER,
        element: LoadablePage(CreateSeriesProductOrder),
      },
      {
        path: EDIT_SERIES_PRODUCT_ORDER,
        element: LoadablePage(EditSeriesProductOrder),
      },
      {
        path: RAW_APPROVAL_VIEW_ROUTE,
        element: LoadablePage(RawApprovalView),
      },
       {
        path: DECORATIVE_APPROVAL_VIEW_ROUTE,
        element: LoadablePage(DecorativeApprovalView),
      },
       {
        path: SERIES_PRODUCT_APPROVAL_VIEW_ROUTE,
        element: LoadablePage(SeriesProductApprovalView),
      },


    ],
  },
];
